import LabelIcon from '@material-ui/icons/Label';

import { JobsLogList } from './JobsLogList';

export const jobsLogResource = {
  list: JobsLogList,
  icon: LabelIcon,
};
